module.exports = __webpack_public_path__ + "img/ico-checklist.1377facb.svg";